import React, { useState } from 'react';

import { AddCircle } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, ListItemButton, ListItemText, TextField, Typography } from '@mui/material';

interface Props {
	onCreate: (name: string, description: string, contextId: string) => Promise<unknown>;
	contextId: string;
	renderButton?: (onClick: () => void) => React.ReactNode;
	open?: boolean;
	onOpenChange?: (open: boolean) => void;
	hideButton?: boolean;
}

const CreateIntegrationEventButton: React.FC<Props> = ({ onCreate, contextId, renderButton, open, onOpenChange, hideButton = false }) => {
	const [dialogOpen, setDialogOpen] = useState(false);
	const isDialogOpen = open ?? dialogOpen;
	const setIsDialogOpen = (next: boolean) => {
		setDialogOpen(next);
		onOpenChange?.(next);
	};
	const [name, setName] = useState('');
	const [description, setDescription] = useState('');

	const handleSave = async () => {
		if (!name.trim()) return;

		await onCreate(name.trim(), description, contextId);
		setIsDialogOpen(false);
		setName('');
		setDescription('');
	};

	return (
		<>
			{hideButton ? null : renderButton ? (
				renderButton(() => setIsDialogOpen(true))
			) : (
				<Box sx={{ mb: 2 }}>
					<ListItemButton onClick={() => setIsDialogOpen(true)} sx={{ pl: 2 }}>
						<AddCircle fontSize="small" sx={{ mr: 1 }} />
						<ListItemText primary={<Typography variant="body1">Create New Integration Event</Typography>} />
					</ListItemButton>
				</Box>
			)}

			<Dialog
				open={isDialogOpen}
				onClose={() => setIsDialogOpen(false)}
				fullWidth
				maxWidth={false}
				slotProps={{
					paper: {
						sx: {
							width: '50vw',
							maxWidth: 'none',
						},
					},
				}}
			>
				<DialogTitle>Create New Integration Event</DialogTitle>
				<DialogContent>
					<TextField
						autoFocus
						fullWidth
						variant="outlined"
						label="Event Name"
						value={name}
						onChange={(e) => {
							const noSpaces = e.target.value.replace(/\s+/g, '');
							setName(noSpaces);
						}}
						sx={{ mt: 1 }}
						helperText="No spaces allowed"
					/>
					<TextField
						fullWidth
						multiline
						minRows={4}
						variant="outlined"
						label="Description"
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						sx={{ mt: 2 }}
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setIsDialogOpen(false)}>Cancel</Button>
					<Button onClick={handleSave} variant="contained" disabled={!name.trim()}>
						Save
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};

export default CreateIntegrationEventButton;
